import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch, defineAsyncComponent, nextTick } from 'vue';

//components
import { DropdownWrapper } from 'ui-shared-components';

//helpers
import { useDropdownSync } from '@white-label-helper/shared-composables';
import isEqual from 'lodash/isEqual';

export type MultiSelectOption = {
  id: string;
  name: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'multi-select',
  props: {
    options: null,
    error: { type: Boolean, default: false },
    errorMessage: { default: '' },
    value: { default: () => [] },
    label: null,
    placeholder: null,
    disabled: { type: Boolean, default: false }
  },
  emits: ["input", "update:value"],
  setup(__props: any, { expose, emit }: { emit: ({
  (e: 'input', val: MultiSelectOption[]): void
  (e: 'update:value', val: MultiSelectOption[]): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { options: MultiSelectOption[], error: boolean, errorMessage: string, value: MultiSelectOption[], label?: string, placeholder?: string, disabled: boolean };

const IconClose = defineAsyncComponent(() => import('@white-label-icon/icon-close'));
const IconSearch = defineAsyncComponent(() => import('@white-label-icon/icon-search'));





const search = ref<string>('');
const isOpen = ref<boolean>(false);
const selected = ref<MultiSelectOption[]>(props.value ?? []);

// Synchronize dropdown state with other dropdowns and modals
useDropdownSync(isOpen);

watch(() => props.value, (newValue: MultiSelectOption[]) => {
  selected.value = newValue ?? [];
});

watch(selected, (newVal: MultiSelectOption[], oldVal: MultiSelectOption[]) => {
  if (isEqual(newVal, oldVal)) return;
  emit('input', newVal)
  emit('update:value', newVal)
})

watch(isOpen, (isNowOpen) => {
  if (!isNowOpen) {
    search.value = '';
  }
});

const filteredOptions = computed<MultiSelectOption[]>(() =>
  props.options
    .filter((option) => option.name.toLowerCase().includes(search.value.toLowerCase()))
    .filter((option) => !selected.value.map(s => s.id).includes(option.id))
);

const selectOption = (item: MultiSelectOption) => {
  selected.value = [...selected.value, item]
  search.value = ''
  isOpen.value = false
};

const onDropdownInput = (item: MultiSelectOption) => {
  selectOption(item)
};
const removeOption = (option: MultiSelectOption) => {
  selected.value = selected.value.filter((selected) => selected.id !== option.id)
};

const dropdownWrapperValue = computed(() => {
  return { name: search.value };
});

const focusFirstOption = () => {
  nextTick(() => {
    const firstItem = document.querySelector('.dropdown-item');
    if (firstItem) {
      (firstItem as HTMLElement).focus();
    }
  })
}

//for making options react to localisation changes
const selectedDisplay = computed<MultiSelectOption[]>(() =>
  selected.value.map(selected => {
    const current = props.options.find(option => option.id === selected.id);
    return current ?? selected;
  })
)

expose({
  selected,
  search,
  isOpen,
  filteredOptions,
  selectOption,
  selectedDisplay,
  removeOption,
  dropdownWrapperValue,
  onDropdownInput,
  focusFirstOption
});

return { __sfc: true,IconClose, IconSearch, props, emit, search, isOpen, selected, filteredOptions, selectOption, onDropdownInput, removeOption, dropdownWrapperValue, focusFirstOption, selectedDisplay, DropdownWrapper }
}

})